import { Component, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { AuthService } from '../../_auth/auth.service';
import { UserDetailsService } from '../../shared/services/user-details.service';
import { saveAs } from "file-saver";
import { formatDate } from '@angular/common';
import { Table } from 'primeng/table';
import { SortEvent } from 'primeng/api';
import { MessageService } from 'primeng/api';

interface Dataset {
  airmanname: String,
  airmanemail: String,
  agenttype: String,
  agentname: String,
  agentaddress: String,
  agentphone: Number,
  agentfax: Number,
  agentemail: String,
  agentpoc: String,
  pocphone: Number,
  pocfax: Number,
  pocemail: String,
  lastupdate: String
}

@Component({
  selector: 'app-search-results',
  templateUrl: './search-results.component.html',
  styleUrl: './search-results.component.scss',
  standalone: false
})
export class SearchResultsComponent implements OnChanges {
  @Input() searchResults: any
  @Input() columns: any
  @Input() isAirmenAgentSearch: boolean
  @Input() resetPagination: boolean
  @Output() pageChange: EventEmitter<any> = new EventEmitter();
  @Output() sortOrderForSearch: EventEmitter<any> = new EventEmitter();
  @Output() agentDelete: EventEmitter<any> = new EventEmitter();

  @ViewChild('table') table: Table;
  users: any;
  public userData: any;
  first: number = 0;
  firstRow: number = 0;
  sortOrder: string;
  isFtnAgentSearch: boolean;
  isAdminUser : boolean;
  selectedAgent : any;
  constructor(private authService: AuthService, private userDetailService: UserDetailsService, private messageService: MessageService){

  }

  ngOnInit() {
    this.userData = this.authService.getUserData();
    this.users = this.searchResults?.items;
    this.isFtnAgentSearch = this.isAirmenAgentSearch?.valueOf();
    this.isAdminUser= this.authService.isInternalAdminUser() || this.authService.isTechSupportUser();
    if(this.resetPagination){
      this.firstRow = 0;
    }
  }
  ngOnChanges(changes: any) {
    this.first = this.firstRow;
    if (changes?.isAirmenAgentSearch || changes?.resetPagination?.currentValue) {
      if (this.table) {
        this.table.reset();
        this.first = 0;
        this.firstRow = 0;
      }
      this.sortOrder = '';
      if(changes?.isAirmenAgentSearch){
        this.isFtnAgentSearch = changes?.isAirmenAgentSearch?.currentValue?.valueOf();
      }
    }
    this.users = changes?.searchResults?.currentValue?.items;

  }

  onSort(event: SortEvent) {
    if (event.order === 1) {
      this.sortOrderForSearch.emit({ order: 'Ascending', field: event.field });
      this.sortOrder = 'Ascending';
    } else if (event.order === -1) {
      this.sortOrderForSearch.emit({ order: 'Descending', field: event.field });
      this.sortOrder = 'Descending';
    }
  }

  onPageChange(event: any) {
    this.firstRow = event.first;
    this.pageChange.emit(event);
  }


  downloadSearchReport() {
    if (this.isFtnAgentSearch) {
      this.userDetailService.getSearchUsersReport(this.sortOrder).subscribe((results: any) => {
        const blob = new Blob([results], { type: 'text/csv' });
        saveAs(blob, 'USAS_Export_' + formatDate(new Date(), 'MMddyyyy_hhmma', 'en-US') + '.csv');
      });
    }
    else {
      this.userDetailService.getArOwnerSearchUsersReport(this.sortOrder).subscribe((results: any) => {
        const blob = new Blob([results], { type: 'text/csv' });
        saveAs(blob, 'USAS_Export_' + formatDate(new Date(), 'MMddyyyy_hhmma', 'en-US') + '.csv');
      });
    }
  }

  deleteAirmenAgent(event:any, agentData ?: any)
  {
    this.selectedAgent = agentData
    const data = {
      agentId: this.selectedAgent.externalUserAgentId,
      deletedBy: this.userData.sub
    }

    console.log(data);
    this.userDetailService.deleteAirmenAgent(data).subscribe((results:any) =>
    {
      if(results.message === 'Success')
        {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Agent details deleted successfully',
          });
          this.agentDelete.emit({refreshGrid :true});
        }

      if(results.message ==='Agent details not found')
        {
          this.messageService.add({
            severity: 'warn',
            summary: 'Warning',
            detail: results.message,
          });
        }        
      })      
  }

  deleteArOwnerAgent(event:any, agentData ?: any)
  {
    this.selectedAgent = agentData
    const data = {
      agentId: this.selectedAgent.arOwnerAgentId,
      deletedBy: this.userData.sub
    }

    this.userDetailService.deleteArOwnerAgent(data).subscribe((results:any) =>
    {
      if(results.message === 'Success')
        {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Agent details deleted successfully',
          });
          this.agentDelete.emit({refreshGrid :true});
        }

      if(results.message ==='Agent details not found')
        {
          this.messageService.add({
            severity: 'warn',
            summary: 'Warning',
            detail: results.message,
          });
        }        
      })      
  }
}
